import React from 'react';
import styles from './Performance.module.css';
import overallPerformanceImg from '../images/overall_performance.png';
import forDetailedBreakdownImg from '../images/for_detailed-breakdown.png';
import deferredReportImg from '../images/deferred_report.png';
import adwReportImg from '../images/adw_report.png';
import reportStatusImg from '../images/report_status.png';

interface OP_BREAKDOWNComponent extends React.FC {
  title?: string;
}

const OP_BREAKDOWN: OP_BREAKDOWNComponent = () => {
  return (
    <div>
      <div className={styles.metricSection}><div className={styles.sectionTitle}>Overall Performance (YTD) Summary Grid</div></div>
      
      <div>
        <div className={styles.metricSection}>
          <p>
            The landing page of the Retail Analytics Dashboard has a summary that provides splits between in-store sales and acehardware.com sales.  Links below the grid allow for more detailed analysis of results for different time frames. Five main metrics are featured in the holistic view of sales grid: 
          </p>
          <ul>
            <li>Sales, Gross Profit $, Gross Margin %, Transactions, Avg. $ / Trans.</li>
          </ul>
        </div>

        <div className={styles.metricSection}>
          <img src={overallPerformanceImg} alt="Overall Performance Summary Grid" style={{ maxHeight: '300px' }}/>
        </div>

        <div className={styles.metricSection}>
          <p>The summary grid is divided into three sections:</p>
          <ol>
            <li>Total - includes both In Store and acehardware.com</li>
            <li>In Store - includes all sales through your Point of Sale (POS) system</li>
            <li>acehardware.com – includes all acehardware.com sales</li>
          </ol>
        </div>

        <div className={styles.metricSection}>
          <p>Each section has four reporting categories:</p>
          <ol>
            <li>TY – represents This Year&apos;s Year-to-Date activity reported</li>
            <li>LY – represents Last Year&apos;s Year-to-Date activity reported</li>
            <li>+/- represents the favorable increase or unfavorable decrease of TY&apos;s results compared to LY&apos;s results as of the reporting date</li>
            <li>% +/- represents the percentage change by taking the +/- value divided by LY&apos;s value</li>
          </ol>
        </div>

        <div className={styles.metricSection}>
          Note on acehardware.com Gross Profit $ and Margin %:
          <ul>
            <li>Acehardware.com Gross Profit $ and Margin % do not include a portion of promotions, specifically vendor funded credits associated with online only promotions.  All site wide offers, Instant Savings, and Integrated promotions are reflected in the acehardware.com Gross Profit $&apos;s and Margin %. </li>
            <li>By not including some vendor funded credits, the margin % will be understated, and in most cases only slightly understated.</li>
            <li>For example, if your acehardware.com Gross Profit $ is $6,000, and you later receive vendor funded promotional credits for $150, your aggregate acehardware.com Gross Profit dollars would actually be $6,150.</li>
          </ul>
        </div>

        <div className={styles.metricSection}>
          <div className={styles.sectionTitle}>Detail Links</div>
          <p>Store level daily detail can be viewed by clicking the links below the summary grid.</p>
        </div>

        <div className={styles.metricSection}>
          <img src={forDetailedBreakdownImg} alt="For Detailed Breakdown" />
        </div>

        <div className={styles.metricSection}>
          <p>The details can be viewed by either calendar or fiscal layout.</p><br/>
          <p>
            The calendar view will match each calendar date of the year to the corresponding date the previous year. For example, January 2, 2020 will compare to January 2, 2019.
          </p><br/>
          <p>
            The fiscal view matches Ace&apos;s fiscal calendar. The fiscal calendar, sometimes called 4-4-5, has weekly periods starting on a Sunday and ending on a Saturday. The periods are a series of 4 weeks, 4 weeks and then 5 weeks throughout the year. This allows comparing the same days of the week. For example, Saturday May 2, 2020 will compare to Saturday May 4, 2019.  This year (2020) has an extra week in period 12. This happens every four years.
          </p><br/>
          <p>
            Each file will open to a summary tab with various levels of aggregation. Click on the Detailed Results tab to see daily information.
          </p><br/>
          <p>
            Multi-Stores have a few options for looking at the detail level. The Chain Analysis section summarizes the entire chain by day for calendar or fiscal. The Chain Analysis by Store has a monthly summary for each store within the chain by calendar or fiscal. <b>Note: The links in the Chain Analysis by Store will take longer to run. You will get a run deferred message, click OK and the report will run in the background. Click on the Deferred Report Status link in the message to see when the report has completed.</b>
          </p>

        </div>

        <div className={styles.metricSection}>
          <img src={deferredReportImg} alt="Deferred Report Notification" style={{ border: '1px solid black' }} />
          <p style={{ fontWeight: 'bold' }}>
            Another way of accessing the report is clicking on the ADW Reports Button.
          </p>
          <img src={adwReportImg} alt="ADW Reports Button" style={{ border: '1px solid black' }} />
          <p style={{ fontWeight: 'bold' }}>
            This will open up the Report Status link at the top of the reporting page.
          </p>
          <img src={reportStatusImg} alt="Report Status" style={{ border: '1px solid black' }} />
        </div>

        <div className={styles.metricSection}>
          <p>
            If you have any questions on the summary or detail information, email{' '}
            <a 
              href="mailto:storeoperations@acehardware.com" 
              className={styles.link}
            >
              storeoperations@acehardware.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

OP_BREAKDOWN.title = 'Holistic View of Sales';
export default OP_BREAKDOWN;
